import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { IndividualProfileWizard } from './IndividualProfileWizard';
import { CompanyProfileWizard } from './CompanyProfileWizard';

export function WizardRouter() {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Route to appropriate wizard based on provider type
  const isCompany = user.providerType?.toLowerCase() === 'company';

  return isCompany ? <CompanyProfileWizard /> : <IndividualProfileWizard />;
}
